import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  Box,
  Paper
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import BusinessIcon from '@mui/icons-material/Business';
import GroupsIcon from '@mui/icons-material/Groups';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import SensorsIcon from '@mui/icons-material/Sensors';

const chroniclesData = [
  {
    id: 1,
    title: "Die Anfänge von DB Regio Bus Mitte",
    subtitle: "Gründung und erste Jahre",
    icon: <HistoryIcon sx={{ fontSize: 60, color: '#E30613' }} />,
    route: '/chronicles/beginning',
    year: "1994-2000",
    description: "Die Entstehungsgeschichte des Unternehmens nach der Bahnreform"
  },
  {
    id: 2,
    title: "Die Bahnreform und Regionalisierung",
    subtitle: "Vom Staatsbetrieb zum modernen ÖPNV",
    icon: <BusinessIcon sx={{ fontSize: 60, color: '#E30613' }} />,
    route: '/chronicles/reform',
    year: "1994-1996",
    description: "Wie die deutsche Bahnreform den Nahverkehr revolutionierte"
  },
  {
    id: 3,
    title: "Expansion und Wachstum",
    subtitle: "Ausbau des Streckennetzes",
    icon: <DirectionsBusIcon sx={{ fontSize: 60, color: '#E30613' }} />,
    route: '/chronicles/expansion',
    year: "2000-2010",
    description: "Die goldenen Jahre der Expansion und Modernisierung"
  },
  {
    id: 4,
    title: "Moderne Flotte und Technologie",
    subtitle: "Innovation im öffentlichen Nahverkehr",
    icon: <EmojiTransportationIcon sx={{ fontSize: 60, color: '#E30613' }} />,
    route: '/chronicles/modernization',
    year: "2010-2020",
    description: "Einführung moderner Busse und digitaler Systeme"
  },
  {
    id: 5,
    title: "Telematik und EcoApp Revolution",
    subtitle: "Digitale Transformation des Busverkehrs",
    icon: <SensorsIcon sx={{ fontSize: 60, color: '#E30613' }} />,
    route: '/user_manuals/telematik',
    year: "2015-heute",
    description: "Wie Telematik und die EcoApp den Arbeitsalltag revolutionierten"
  },
  {
    id: 6,
    title: "Menschen bei DB Regio Bus",
    subtitle: "Die Gesichter hinter dem Service",
    icon: <GroupsIcon sx={{ fontSize: 60, color: '#E30613' }} />,
    route: '/chronicles/people',
    year: "Seit 1994",
    description: "Geschichten von Mitarbeitern und ihre Erfahrungen"
  }
];

export const ChroniclesMain = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, mb: 4, background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)' }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ color: '#E30613', fontWeight: 'bold' }}>
            Chronik
          </Typography>
          <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#666' }}>
            DB Regio Bus Mitte
          </Typography>
          <Typography variant="body1" sx={{ maxWidth: '800px', mx: 'auto', fontSize: '1.1rem', lineHeight: 1.6 }}>
            Entdecken Sie die Geschichte unseres Unternehmens - von den ersten Tagen nach der Bahnreform 
            bis hin zu modernen Innovationen im öffentlichen Nahverkehr. Eine Reise durch drei Jahrzehnte 
            Mobilität in der Region Frankfurt am Main.
          </Typography>
        </Box>
      </Paper>

      <Grid container spacing={3}>
        {chroniclesData.map((chronicle) => (
          <Grid item xs={12} md={6} lg={4} key={chronicle.id}>
            <Card 
              sx={{ 
                height: '100%', 
                transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
                }
              }}
            >
              <CardActionArea 
                onClick={() => navigate(chronicle.route)}
                sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
              >
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  py: 3,
                  background: 'linear-gradient(135deg, #f8f8f8 0%, #ececec 100%)'
                }}>
                  {chronicle.icon}
                </Box>
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                  <Typography variant="overline" color="primary" sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                    {chronicle.year}
                  </Typography>
                  <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
                    {chronicle.title}
                  </Typography>
                  <Typography variant="subtitle1" color="primary" gutterBottom sx={{ fontStyle: 'italic' }}>
                    {chronicle.subtitle}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
                    {chronicle.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Paper elevation={1} sx={{ mt: 4, p: 3, backgroundColor: '#f9f9f9' }}>
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', fontStyle: 'italic' }}>
          Diese Chronik wurde zusammengestellt aus öffentlich verfügbaren Quellen und internen Unterlagen. 
          Alle Angaben ohne Gewähr. Stand: September 2025
        </Typography>
      </Paper>
    </Container>
  );
};

export default ChroniclesMain;